import React, { useState, useEffect } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { SliderFormatterComponent } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import { toast } from "react-toastify";
import Response_Processing from "../../../layout/Others/Response_Processing";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
import { IconDeleteFigma, IconEditFigma, IconMyWeb } from "../../../Assets/MyIcons";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { FaEllipsisVertical } from "react-icons/fa6";

function LandingPages() {


  const labelSource = 'landing-page'
  const headers = getItemToken('access_token')
  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/landing-page/index`
  const bannerToggle = `${BaseUrl}/admin/landing-page/update_status`
  const multiDelete = `${BaseUrl}/admin/landing-page/delete`
  const labelApi = `${BaseUrl}/admin/Label-Management/list-source?source=${labelSource}`

  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [labelDisplay, setLabelDisplay] = useState([]);

  const ActionFormatterComponent = ({ cell, row, link, action, viewLink }) => {
    return (
      <div className="editdropdown ">
        <span className="editdropdown-button">
          <FaEllipsisVertical className="theme-text-color" />
        </span>
        <div className="editdropdown-menu theme-bg-color">
          <Link to={`${viewLink}${row?.id}`} target="_blank" className="theme-text-color  theme-bg-color">
            <IconMyWeb styled={{ width: "24px", height: "24px", className: "text-dark" }} />
            <span className="theme-text-color">
              <MessageBox text="View" classname='ms-2 theme-text-color'></MessageBox>
            </span>
          </Link>
          <Link to={`${link}${row?.id}`} className="theme-text-color  theme-bg-color">
            <IconEditFigma styled={{ width: "20px", height: "20px" }} />
            <span className="theme-text-color">
              <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
            </span>
          </Link>
          <div onClick={() => action(row?.id)} className="commonActionPadding theme-bg-color"  >
            <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
            <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
          </div>
        </div>
      </div>
    );
  };

  const columns = [
    {
      dataField: "id",
      text: "Id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
    },
    {
      dataField: "title",
      text: "PAGES",
    },
    {
      dataField: "status",
      text: "Set As Front Page",
      formatter: (cell, row) => <SliderFormatterComponent cell={cell} row={row} action={handleToggle} />,
    },

    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => <ActionFormatterComponent cell={cell} row={row} link={"/edit-landing-page/"} viewLink={"/landing-page-preview/"} action={singleDelete} />,
    }
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: Number(filteredData?.length)
    }]
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    style: { width: '30px' },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const fetchData = async () => {
    try {
      const response = await axios.get(`${listApi}`, { headers: headers });
      const result = response?.data?.data;
      setApiData(result);
      setFilteredData(result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.delete(`${multiDelete}/${itemToDelete?.[0]}`, { headers: headers, });
      const result = response?.data;
      if (result?.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setItemToDelete([])
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const confirmToggle = async () => {
    setShowOverlay(true);
    setShowModal(false);
    try {
      const formData = {};
      const newStatus = currentItem?.status === 1 ? 0 : 1;
      formData['landing_page_id'] = currentItem?.id;
      formData['status'] = newStatus
      const response = await axios.post(`${bannerToggle}`, formData, { headers: headers });
      const result = response.data
      if (result.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setCurrentItem(null);
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };



  // Api links end 

  const handleToggle = async (item) => {
    setCurrentItem(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToDelete([]);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  useEffect(async () => {
    await fetchData();
    await labelFetch()
  }, [withOutRefresh]);


  return (
    <>
      {showOverlay && <Response_Processing />}
      {showModal && <AdminSliderModal modelClose={showModal} sliderClose={closeModal} sliderAction={confirmToggle} buttonText={currentItem?.banner} />}
      {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
      <AdminNavbar heading={labelDisplay?.[0]?.title} totalDataLength={apiData?.length} deleteCount={itemToDelete?.length} navigation={"/add-landing-page"} deleteMethod={openModal} navText={labelDisplay?.[1]?.title} />
      <div className="theme-bg-color p-3 rounded-2 bootstrapTable  multi-delete-width" >
        <BootstrapTable keyField="id" pagination={paginationFactory(options)} columns={columns} data={filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" />
      </div>
    </>
  );
}

export default LandingPages;